/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Modal,
    Form,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import * as API from "Front/api/nextVisitInstructions";


const AddEditNextVisitInstruction = ({ mode, data, ModalStatus, resetRowData, setModalStatus }) => {
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const inputHandler = (e) => {
        let saveFormData = formData;
        saveFormData[e.target.name] = e.target.value;
        setFormData({ ...formData, ...saveFormData });
        validate();
    };

    const validate = () => {
        let post = formData;
        let errArr = errors;
        let errflag = true;
        if (post.instruction && post.instruction != "") {
            errArr.instruction = "";
        } else {
            errArr.instruction = "error";
            errflag = false;
        }
        setErrors({ ...errArr });
        return errflag;
    };

    const submitHandler = async (event) => {
        event.preventDefault();
        if (validate()) {
            setIsLoading(false);
            let sentData = new FormData();
            sentData.append("instruction", formData?.instruction);
            try {
                let resp;
                if (mode === "add") {
                    sentData.append("clinicId", localStorage.getItem("clinicId"));
                    resp = await API.addNextVisitInstruction(sentData)
                } else {
                    sentData.append("id", formData?._id);
                    resp = await API.updateNextVisitInstruction(sentData);
                }
                console.log(resp, "----------resp")
                if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
                    resetRowData(true)
                }
            } catch (error) {
                console.log(error, "-----------error")
            }
        }
    };

    useEffect(() => {
        if (ModalStatus === true && mode === "edit") {
            setFormData({ ...data });
        }
    }, [ModalStatus]);




    return (
        <span>
            <button
                type="button"
                className="btn-fill btn btn-primary btn btn-default mangeBtns"
                onClick={(e) => setModalStatus(true)}
            >
                Add
            </button>
            <Modal
                show={ModalStatus}
                onHide={() => { setErrors({}); resetRowData(false) }}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        {mode === "add" ? "Add" : "Edit"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="Knowledge-Share">
                    <Row>
                        <Col md={12}>
                            <Form
                                horizontal
                                noValidate
                            // validated={validated}
                            // onSubmit={(e) => submitHandler(e)}
                            >
                                <Col sm={12} md={12}>
                                    <FormGroup>
                                        <Col componentClass={ControlLabel} sm={12} md={4}>
                                            Next Visit Instruction<span className="star">*</span>
                                        </Col>
                                        <Col sm={12} md={6}>
                                            <Row>
                                                <Col sm={12} md={9}>
                                                    <FormControl
                                                        type="text"
                                                        autocomplete="off"
                                                        name="instruction"
                                                        value={formData.instruction ? formData.instruction : ""}
                                                        onChange={(e) => {
                                                            inputHandler(e);
                                                        }}
                                                        placeholder="Instruction"
                                                        className={
                                                            "insulin-input " +
                                                            (errors.instruction ? errors.instruction : "")
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        type="submit"
                        className="btn-fill btn btn-primary"
                        disabled={isLoading || errors.instruction}
                        onClick={(e) => submitHandler(e)}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </span>
    )
}

export default AddEditNextVisitInstruction